import SortItemModel from './item.model.js';
const model = {
    name: 'Sort',
    properties: {
        choices: {},
        value: {
            type: 'model',
            model: SortItemModel,
            exportKey: ['value[0]'],
            name: 'criteria',
        },
    },
};
export default model;
